import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { HamburgerIcon } from 'icons';
import { Button } from 'components/controls';
import styles from './SiteNavBarDropDownMenu.scss';

export default function SiteNavBatDropDownMenu(props) {
  const { children, className } = props;
  const [opened, setOpened] = useState(false);

  const handleSetOpened = () => {
    setOpened(!opened);
  };

  return (
    <div className={classnames(styles.container, className)}>
      <Button
        label={<HamburgerIcon expanded={opened} />}
        onClick={handleSetOpened}
        className={styles.hamburger}
      />
      {opened && <div className={styles.list}>{children}</div>}
    </div>
  );
}

SiteNavBatDropDownMenu.propTypes = {
  className: PropTypes.string,
};

SiteNavBatDropDownMenu.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/components/SiteNavBar/SiteNavBarDropDownMenu.jsx